<template>
  <div class="announcement-bar section_1 flex-row" @click="goDetail(currentItem)">
    <div class="image-text_1 flex-row justify-between">
      <img
        class="label_1"
        referrerpolicy="no-referrer"
        src="../assets/img/icon-gg.png"
      />
      <div class="scroll-wrap">
        <div ref="scrollList" class="scroll-list" @transitionend="onTransitionEnd">
          <div
            v-for="(item, index) in displayList"
            :key="index"
            class="scroll-item text-group_1"
            :class="{ 'empty-announcement': !item.title }"
          >
            {{ item.title || '暂无公告' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumnIdByName } from '../../utils/common'
import { contentList } from '../../api/content'

export default {
  name: 'AnnouncementBar',
  data() {
    return {
      list: [],
      scrolling: false,
      timer: null
    }
  },
  computed: {
    displayList() {
      if (!this.list.length) return [{}]
      return this.list
    },
    currentItem() {
      return this.list[0] || {}
    }
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy() {
    this.stopScroll()
  },
  methods: {
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    },
    async loadData() {
      const categoryId = getColumnIdByName('对外公告')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, pageSize: 5 })
        this.list = data.rows || []
        this.startScroll()
      } catch (e) {
        console.error('获取对外公告失败', e)
      }
    },
    startScroll() {
      this.stopScroll()
      if (this.list.length <= 1) return
      this.scrolling = false
      const el = this.$refs.scrollList
      if (el) {
        el.style.transition = 'none'
        el.style.transform = 'translate3d(0, 0, 0)'
      }
      this.timer = setInterval(() => {
        if (this.scrolling) return
        this.scrolling = true
        const el = this.$refs.scrollList
        if (!el) return
        el.style.transition = 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)'
        void el.offsetHeight
        el.style.transform = 'translate3d(0, -40px, 0)'
      }, 3000)
    },
    onTransitionEnd(e) {
      if (e.propertyName !== 'transform') return
      if (!this.scrolling) return
      const el = this.$refs.scrollList
      if (!el) return
      el.style.transition = 'none'
      el.style.transform = 'translate3d(0, 0, 0)'
      this.list.push(this.list.shift())
      void el.offsetHeight
      this.scrolling = false
    },
    stopScroll() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section_1 {
  background-size: 100% 100%;
  background: #fff;
  height: 40px;
  border-radius: 8px;
  .image-text_1 {
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    &:active {
      transform: scale(0.98);
      opacity: 0.85;
    }

    .label_1 {
      width: 29px;
      height: 29px;
      margin-left: 8px;
      flex-shrink: 0;
    }
    .scroll-wrap {
      flex: 1;
      min-width: 0;
      height: 40px;
      margin-left: 8px;
      overflow: hidden;
    }
    .scroll-list {
      display: block;
      will-change: transform;
    }
    .scroll-item {
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .text-group_1 {
      color: rgba(34, 34, 34, 1);
      font-size: 12px;
      text-align: left;
    }
    .empty-announcement {
      color: #909399;
    }
  }
}
</style>
